import React, { useEffect, useState } from 'react'

import { useLightMode } from '@/hooks/useLightMode'
import Image from 'next/image'

import { Modal as DarkModal, FileThumbnail } from '@hivewatch/dark'

import { IncidentNoteVideoPlayer } from '../components/IncidentNoteVideoPlayer'
import { darkModalBodyStyles, previewImageStyles } from './PreviewMedia.styles'

export const PreviewMedia = ({
  onClose,
  isOpen,
  previewFile,
}: {
  onClose: () => void
  isOpen: boolean
  previewFile: File
}) => {
  const colorScheme = useLightMode()
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)

  useEffect(() => {
    const url = URL.createObjectURL(previewFile)
    setPreviewUrl(url)

    return () => {
      URL.revokeObjectURL(url)
    }
  }, [previewFile])

  const renderContent = () => {
    if (!previewUrl) return null

    if (previewFile?.type.startsWith('image/')) {
      return (
        <Image
          alt={previewFile.name}
          height={800}
          src={previewUrl}
          style={previewImageStyles}
          width={800}
        />
      )
    }

    if (previewFile?.type.startsWith('application/pdf')) {
      return (
        <embed
          data-testid='AddNote:embed'
          height={800}
          src={previewUrl}
          type='application/pdf'
          width='100%'
        />
      )
    }

    if (previewFile?.type.startsWith('video/')) {
      return <IncidentNoteVideoPlayer videoUrl={previewUrl} />
    }

    // No inline preview for this format — the file is still attachable
    return <FileThumbnail colorScheme={colorScheme} name={previewFile.name} />
  }

  return (
    <DarkModal
      bodyStyleOverrides={darkModalBodyStyles}
      colorScheme={colorScheme}
      isOpen={isOpen}
      isSaveHidden
      maxW='900px'
      onClose={onClose}
      title={previewFile.name}
      zIndex={1500}
    >
      {renderContent()}
    </DarkModal>
  )
}
